import WithdrawLiquidityInterface from "./WithdrawLiquidityInterface";

export default WithdrawLiquidityInterface;
